export const env = {
  REACT_APP_AUTH_API: process.env.REACT_APP_AUTH_API,
  REACT_APP_PASSWORD_MASK_SECRET: process.env.REACT_APP_PASSWORD_MASK_SECRET,
  REACT_APP_AUTH_PAGE_URL: process.env.REACT_APP_AUTH_PAGE_URL,
  REACT_APP_STATIC_PAGE_URL: process.env.REACT_APP_STATIC_PAGE_URL,
  REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  REACT_APP_GOOGLE_AUTH_URL: process.env.REACT_APP_GOOGLE_AUTH_URL
};
